import { useMemo } from 'react';
import { getExtensionValueSync } from '../config/client-extensions';

/**
 * Hook pour récupérer une valeur d'extension
 * @param {string} key - Clé de l'extension (ex: 'LoginImages', 'MetaValues', 'ConsentBanner')
 * @returns {*} Valeur de l'extension
 */
export const useExtension = (key) => {
  return useMemo(() => {
    return getExtensionValueSync(key);
  }, [key]);
};

export default useExtension;
